<template>
	<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18">
		<path
			fill="currentColor"
			fill-rule="evenodd"
			d="M3 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm12 0a3 3 0 1 0 0 6 3 3 0 0 0 0-6ZM0 15a3 3 0 1 1 6 0 3 3 0 0 1-6 0Zm15-3a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z"
			clip-rule="evenodd"
		/>
	</svg>
</template>
